import React from 'react'
import SERVICEPC from '../../../../app/assets/images/custom-service-pc.png'
import ButtonComponent from '../../../atoms/Button/Button';
import { useNavigate } from 'react-router-dom';

const CustomService = () => {
    const navigate = useNavigate()
    return (
        <div className='flex flex-col md:flex-row bg-custom-service-bg bg-no-repeat bg-center bg-cover w-full'>
            <div className='text-center md:text-start p-6 lg:p-12 lg:pr-8 lg:pl-24 text-white flex flex-col gap-2'>
                <div className='text-3xl xl:text-4xl font-bold mb-4 leading-snug'>Start your custom <br />
                    software development <br />
                    project today</div>
                <div className='text-base lg:text-xl leading-7 md:leading-8 2xl:pr-72'>Ready to take your business to the next level with a
                    custom-built software solution? Our expert team is here
                    to help you bring your vision to life. Contact us today
                    to schedule a free consultation.</div>
                <ButtonComponent
  className="mx-auto md:mx-0 rounded-2xl shadow-custom-yellow bg-yellow text-black p-3 text-sm relative mt-4"
  labelClassname="text-base lg:text-xl font-bold font-sans rounded-full"
  inputStyles={{
    minWidth: '180px',
    width: '180px',
    height: '60px',
  }}
  label="Get in touch"
  onClick={() => navigate('/contactus')}
/>
            </div>
            <img src={SERVICEPC} className='w-full my-auto md:w-auto md:h-[200px] lg:h-[300px] xl:h-[350px] 2xl:h-[520px] object-contain' />
        </div>
    )
}

export default CustomService
